import { useSyncExternalStore } from "react";

const subscribe = () => () => {};

// `true` au rendu serveur et au rendu d'hydratation (snapshot serveur), `false` ensuite et à
// tout montage ultérieur côté client : seule l'hydratation doit reproduire le HTML du serveur.
export const useIsHydrating = () =>
	useSyncExternalStore(
		subscribe,
		() => false,
		() => true
	);
